import { ComparatorResult } from "@regrello/core-utils";

export const COMPARATOR_RESULT_IF_BOTH_VALUES_UNDEFINED = ComparatorResult.EQUAL;
export const COMPARATOR_RESULT_IF_ONLY_VALUE_A_UNDEFINED = ComparatorResult.AFTER;
export const COMPARATOR_RESULT_IF_ONLY_VALUE_B_UNDEFINED = ComparatorResult.BEFORE;
